<ng-container *ngIf="deleted">
    <img class="icon"
         src="assets/images/user-with-star.svg"/>
    <h1>
        {{ Localization.AccountDeletedTitle | translate}}
    </h1>
    <h4>{{ Localization.AccountDeletedText | translate}}</h4>
</ng-container>
<div class="page-spinner"
     *ngIf="!deleted">
    <mdb-spinner spinnerType="big"></mdb-spinner>
</div>